import React from 'react';

export default function Header() {
  return (
    <div>
      <h1>Vaccine data across economic classifications</h1>
      <p>
        The World Bank classifies economies for analytical purposes into four
        income groups: low, lower-middle, upper-middle, and high income.
      </p>
      <p>The below charts split vaccine data across these classifications.</p>
      <div className="key">
        <div className="key-list">
          <div className="key-box unvax" />
          <div className="key-name">Unvaccinated</div>
        </div>
        <div className="key-list">
          <div className="key-box single" />
          <div className="key-name">One vaccination</div>
        </div>
        <div className="key-list">
          <div className="key-box double" />
          <div className="key-name">Two vaccinations</div>
        </div>
        <div className="key-list">
          <div className="key-box booster" />
          <div className="key-name">Three or more vaccinations</div>
        </div>
      </div>
    </div>
  );
}
